<script lang="ts">
	import type { HTMLAttributes } from "svelte/elements";
	import { MediaQuery } from "svelte/reactivity";

	const {
		children,
		class: customClass,
		speed = 1,
		flowDirection: direction,
		forceSlidingOnMobile = false,
		...props
	}: HTMLAttributes<HTMLDivElement> & {
		speed?: number;
		flowDirection: "left" | "right";
		forceSlidingOnMobile?: boolean;
	} = $props();

	const isDesktop = new MediaQuery("hover: hover", false);
	const directionCoefficient = $derived({ left: 1, right: -1 }[direction]);

	let div = $state<HTMLDivElement>();
	let scrollable = $derived(div !== undefined && div.scrollWidth > div.clientWidth);

	$effect(() => {
		let animationId = window.requestAnimationFrame(function scroll() {
			if (!div) {
				return;
			}
			const delta = div.scrollLeft - (div.scrollWidth / 2) * directionCoefficient;
			if (Math.sign(delta) === directionCoefficient) {
				div.scrollTo({ left: delta / 2 });
			} else if ((isDesktop.current || forceSlidingOnMobile) && !div.matches(":hover") && scrollable) {
				div.scrollBy({ left: speed * directionCoefficient });
			}
			animationId = window.requestAnimationFrame(scroll);
		});

		return (): void => {
			window.cancelAnimationFrame(animationId);
		};
	});
</script>

<svelte:window
	onresize={(): void => {
		scrollable = div !== undefined && div.scrollWidth > div.clientWidth * (scrollable ? 2 : 1);
	}}
/>

<div
	{...props}
	class={[
		customClass,
		"flex overflow-x-auto no-scrollbar *:shrink-0",
		{ left: "flex-row", right: "flex-row-reverse" }[direction],
		!scrollable && "justify-center",
	]}
	bind:this={div}
>
	{@render children?.()}
	{#if scrollable}
		{@render children?.()}
	{/if}
</div>
